import React from "react";

import { tw } from "~/shared";

type SkeletonProps = {
  className?: string;
  width?: string;
  height?: string;
};

type SkeletonCircleProps = {
  className?: string;
  size?: string;
};

type SkeletonCardProps = {
  className?: string;
  children: React.ReactNode;
};

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => (
  <div
    className={tw("h-4 w-full animate-pulse rounded bg-gray-200", className)}
  />
);

export const SkeletonCircle: React.FC<SkeletonCircleProps> = ({
  className,
}) => (
  <div
    className={tw("size-8 animate-pulse rounded-full bg-gray-200", className)}
  ></div>
);

export const SkeletonButton: React.FC<SkeletonProps> = ({ className }) => (
  <div
    className={tw(
      "h-10 w-full animate-pulse rounded-lg bg-gray-200",
      className,
    )}
  ></div>
);

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  className,
  children,
}) => (
  <div className={tw("rounded-lg border border-gray-200 p-4", className)}>
    {children}
  </div>
);

type SkeletonTextProps = {
  lines?: number;
  className?: string;
  lastLineWidth?: string;
};

export const SkeletonText: React.FC<SkeletonTextProps> = ({
  lines = 1,
  className,
  lastLineWidth = "w-3/4",
}) => (
  <div className={tw("space-y-2", className)}>
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton
        key={index}
        width={index === lines - 1 ? lastLineWidth : "w-full"}
        height="h-4"
      />
    ))}
  </div>
);
